import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

export type TLanguages = {
  [lang: string]: {
    [key: string]: string
  }
}

export enum ELanguageKey {
  'de' = 'de',
  'en' = 'en',
}
export const loadI18Next = (languages: TLanguages): void => {
  i18n.use(initReactI18next).init({
    resources: {
      [ELanguageKey.de]: {
        translation: languages[ELanguageKey.de],
      },
      [ELanguageKey.en]: {
        translation: languages[ELanguageKey.en],
      },
    },
    lng: ELanguageKey.de,
    fallbackLng: ELanguageKey.en,
    interpolation: {
      escapeValue: false,
    },
    nsSeparator: ':::',
    keySeparator: '::',
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    },
  })
}
